/**
 * Viewport breakpoint values, mirroring
 * `src/themes/ghab/styles/common/00-settings/responsive-breakpoints.scss`.
 *
 * If a value here ever drifts from the SCSS, the theme and the modules will
 * disagree about "is this viewport mobile?" — keep them in sync, or move
 * both to a generated source if drift becomes a real problem.
 */
export const BREAKPOINTS = {
    ms: 539,
    m: 768,
    l: 992,
    xl: 1440,
    xxl: 1778
} as const;

export type BreakpointName = keyof typeof BREAKPOINTS;

/**
 * Returns true when the browser viewport is strictly narrower than the named
 * breakpoint. Returns false during SSR (no `window`).
 *
 * Call sites are responsible for re-evaluating on window `resize` (e.g. via a
 * componentDidMount listener that triggers setState). This helper deliberately
 * does NOT manage subscriptions — keeping it a pure getter avoids surprises
 * about who owns the listener lifecycle.
 */
export function isViewportBelow(breakpoint: BreakpointName): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    return window.innerWidth < BREAKPOINTS[breakpoint];
}
